import React, { useState, useContext, useEffect } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRow, IonCol, IonLabel, IonInput, IonItem, IonTextarea, IonSelect, IonSelectOption, IonItemDivider, IonIcon, useIonViewWillEnter, IonButton, IonList, IonButtons, IonBackButton } from '@ionic/react'
import db from '../../resources/db';
import invoicePattern from '../Invoice/InvoicePattern';
import { toastController } from '@ionic/core';
import AddProduct from '../CreateInvoice/AddProduct';
import { ConfigContext } from '../../contexts/ConfigContext';
import { useRouter } from '../../resources/Hooks';
import { trash } from 'ionicons/icons';
import invoicePatternGST from '../Invoice/InvoicePatternGST';
import { updateArray } from '../../contexts/helperFn';
import { APPLINKS } from '../../resources/AppConst';

var moment = require('moment');

const EditInvoice = ({ match }) => {
    const router = useRouter();
    const { getCustomerList, getCompany } = useContext(ConfigContext);

    const [billid, setBillid] = useState(0)
    const [CustomerList, setCustomerList] = useState([])
    const [Company, setCompany] = useState({})
    const [gstenabled, setGstenabled] = useState(false)
    const [uid, setUid] = useState(0)
    const [Products, setProducts] = useState([])
    const [CustomerName, setCustomerName] = useState('Cash')
    const [CustomerContact, setCustomerContact] = useState('')
    const [CustomerDetails, setCustomerDetails] = useState('')
    const [CustomerGST, setCustomerGST] = useState('')
    const [date, setDate] = useState(Date())
    const [saletype, setSaletype] = useState('');

    const [invoiceNo, setinvoiceNo] = useState('')
    const [gstinvoiceNo, setgstinvoiceNo] = useState('')

    const clearAll = () => {
        setBillid(0)
        setCustomerList([])
        setCompany({})
        setGstenabled(false)
        setUid(0)
        setProducts([])
        setCustomerName('Cash')
        setCustomerContact('')
        setCustomerDetails('')
        setCustomerGST('')
        setDate(Date())
        setSaletype('');
        setinvoiceNo('')
        setgstinvoiceNo('')
    }

    useEffect(() => {
        getCustomerList().then(res => {
            setCustomerList(res)
        })
        getCompany().then(res => {
            setCompany(res)
        })

        let billno = match.params.id;
        db.invoices.get({ "id": parseInt(billno) }).then((res) => {
            // console.log(res, billno);
            setUid(res.id)
            setBillid(res.invoiceId)
            setCustomerName(res.customerName);
            setCustomerContact(res.customerContact);
            setCustomerDetails(res.customerDetails);
            setCustomerGST(res.customerGST)
            setDate(res.billDate);
            setProducts(res.products);
            setGstenabled(res.gstEnabled);
            setinvoiceNo(res.invoiceNo);
            setSaletype(res.saletype);
            if (res.gstEnabled) {
                // console.log("gst enabled", res.invoiceNo);
                let ginv = Number(res.invoiceNo?.split("-")[1]);
                setgstinvoiceNo(ginv)
            }
        })

        document.getElementById('customerName').getInputElement().then(res => {
            res.setAttribute('list', 'customerList');
        })

        return () => {
            clearAll()
        }
    }, [getCompany, getCustomerList, match.params.id])

    // calucate subtotal & total
    let subTotal = 0;
    if (Products.length) {
        subTotal = Products.reduce((sum, product) => {
            let totalsum = sum + product.amount;
            return totalsum
        }, 0)
    }
    let gstTotal = 0;
    if (Products.length) {
        gstTotal = Products.reduce((sum, product) => {
            let totalsum = sum + product.gstAmt;

            return totalsum
        }, 0)
    }

    let total = subTotal;
    if (gstenabled) {
        total = subTotal + gstTotal;
    }

    /** Add Product to table */
    const addProduct = (item) => {
        setProducts([...Products, item])
    }

    /** Remove product item by id
     * @param id
     * @param pname Product Name
     * @param quan - Quantity
     */
    const removeProduct = (id, pname, quan) => {
        // console.log(id, pname, quan);

        let pLeft = Products.filter(product => (product.id !== id))
        setProducts(pLeft)
        db.stocks.where("productName").equals(pname).modify((value, ref) => {
            let q = value.quantity
            ref.value.quantity = q + parseInt(quan)
            console.log("Stock updated");
        })
    }

    /** Print Bill from PDF
     * @param invoice
     */
    const printBill = (invoice) => {
        let print = document.getElementById('print').contentWindow;
        invoice.gstEnabled ?
            print.document.write(invoicePatternGST(invoice))
            : print.document.write(invoicePattern(invoice))
        print.document.close();
        print.focus();
        print.print();
        // console.log(print);

    }



    /**Generate Bill , creates invoices and add data to ledger */
    const updateBill = async () => {
        console.log("Updatibng Bill");
        let billDate = moment(date).format('ll');

        /** Invoice Json */
        const invoice = {
            id: uid,
            gstEnabled: gstenabled,
            invoiceNo: gstenabled ? `G-${gstinvoiceNo}` : invoiceNo,
            billDate: billDate,
            customerName: CustomerName,
            customerGST: CustomerGST,
            customerDetails: CustomerDetails ? CustomerDetails : "",
            customerContact: CustomerContact ? CustomerContact : "",
            companyName: Company.name,
            companyAddress: Company.address,
            companyContact: Company.contact,
            gst: Company.gst,
            products: Products,
            saletype: saletype,
            subtotalAmt: subTotal,
            gstTotal: gstTotal,
            totalAmt: total,
        }

        const ledger = {
            billId: invoice.id,
            billNo: invoice.invoiceNo,
            customerName: CustomerName,
            customerGST: CustomerGST ? CustomerGST : "",
            customerDetails: CustomerDetails ? CustomerDetails : "",
            customerContact: CustomerContact ? CustomerContact : '',
            date: billDate,
            debit: parseFloat(total),
            credit: parseFloat(0),
            receivable: parseFloat(total),
            payable: 0,
            isCustomer: 1, //true
        }
        // console.log(invoice);
        // add to db
        if (invoice.products.length) {

            db.db.transaction('rw', db.invoices, db.ledger, db.stocks, async () => {
                await db.invoices.update(billid, invoice).then((res) => {
                    console.log('Bill Updated', res);
                })
                let ledgerID = await db.ledger.get({ billId: invoice.id })
                console.log(ledgerID, invoice.id);

                await db.ledger.update(ledgerID.id, ledger).then(res => {
                    console.log('ledger updated', res);
                })

                invoice.products.forEach(async (item) => {
                    let stock = await db.stocks.where("productName").equals(item.name).first();
                    // find index to update
                    // stock is null if product is not in stock
                    if (stock) {
                        let logs = stock?.log;
                        let index = logs?.findIndex(log => log.billId === invoice.id);

                        // console.log('StockLog: ', logs);
                        // console.log('Index: ', index, logs[index]);
                        let logentry = {
                            ...logs[index],
                            to: ledger.customerName,
                            billNo: invoice.invoiceNo,
                            date: billDate,
                            type: "Sales",
                            quantity: item.quantity,
                            rate: item.price,
                            amount: item.amount,
                        };

                        const newLogs = updateArray(logs, index, logentry);

                        // console.log("Log Enry ", logentry);
                        // console.log('new log', newLogs);
                        await db.stocks.where("productName").equals(item.name).modify((value, ref) => {
                            // console.log(value, ref);
                            // ref.value.log = []
                            value.log = newLogs;
                        }).then(async (res) => {
                            console.log('updated stocks', res);
                        })
                    } else {
                        if (item.name.length) {
                            let stockdata = {
                                productName: item.name,
                                quantity: parseFloat(item.quantity) * -1,
                                rate: parseFloat(item.price),
                                purchaseRate: 0,
                                gstRate: parseFloat(item.gstr ? item.gstr : 0),
                                hsn: '',
                                log: [],
                            };

                            let logentry = {
                                id: `stk_${Date.now()}`,
                                to: ledger.customerName,
                                billNo: invoice.invoiceNo,
                                billId: ledger.billId,
                                date: billDate,
                                type: "Sales",
                                quantity: item.quantity,
                                rate: item.price,
                                amount: item.amount,
                            };
                            await db.stocks.put(stockdata).then((res) => {
                                console.log('Product Item added.', res);
                                db.stocks.where("productName").equals(item.name).modify((value, ref) => {
                                    // console.log(value, ref);
                                    // ref.value.log = []
                                    value.log.push(logentry);
                                })
                            });
                        }
                    }
                })
            }).then(() => {
                printBill(invoice)
                const url = APPLINKS.invoice + `/${invoice.id}`;
                router.replace(url)

                // eslint-disable-next-line no-restricted-globals
                // location.reload();
            }).catch(e => { console.err(e); })

        } else {

            toastController.create({
                color: 'danger',
                duration: 2000,
                message: "ERROR UPDATING BILL",
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });
        }

    }

    const ProductTable = (
        <IonList className='product-table' >
            <IonItem color='medium'>
                <IonCol style={{ textAlign: "center" }}>S.No.</IonCol>
                <IonCol className='ion-padding-horizontal' style={{ textAlign: "center" }}>Product Name </IonCol>
                <IonCol style={{ textAlign: "center" }}>Quantity</IonCol>
                <IonCol style={{ textAlign: "center" }}>Unit price</IonCol>
                <IonCol style={{ textAlign: "center" }}>Amount </IonCol>
                {gstenabled && (<>
                    <IonCol style={{ textAlign: "center" }}>GST Rate </IonCol>
                    <IonCol style={{ textAlign: "center" }}>GST Amt </IonCol>
                    <IonCol style={{ textAlign: "center" }}>Total </IonCol>
                </>
                )}
                <IonCol style={{ textAlign: "center" }}>Remove </IonCol>
            </IonItem>
            {Products && Products.map(((item, i) => {
                return (
                    <IonItem key={item.id}>
                        <IonCol style={{ textAlign: "center" }}>{i + 1}</IonCol>

                        <IonCol style={{ textAlign: "center" }}>{item.name}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{item.quantity}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{parseFloat(item.price).toFixed(2)}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{parseFloat(item.amount).toFixed(2)}</IonCol>

                        {gstenabled && (<>
                            <IonCol style={{ textAlign: "center" }}>{item.gstr}</IonCol>
                            <IonCol style={{ textAlign: "center" }}>{parseFloat(item.gstAmt).toFixed(2)}</IonCol>
                            <IonCol style={{ textAlign: "center" }}>{parseFloat(item.total).toFixed(2)}</IonCol>
                        </>)}

                        <IonCol style={{ textAlign: "center" }}><IonIcon icon={trash} style={{ cursor: 'pointer' }} onClick={() => removeProduct(item.id, item.name, item.quantity)}></IonIcon></IonCol>
                    </IonItem>
                )


            }))}
        </IonList>
    )

    const customers = CustomerList.length ? (
        CustomerList.map((p) => {
            // console.log(p);
            return (
                <option key={p} value={p}></option>
            )
        })
    ) : (null)


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Edit Invoice</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>
                <IonRow>
                    <IonCol sizeMd='3'>
                        <IonItem>
                            <IonLabel position='floating'>Customer Name</IonLabel>
                            <IonInput type='text' id="customerName" debounce={1000} autoCapitalize='word' autocomplete='on' placeholder='Name' name='' value={CustomerName} onIonInput={(e) => {
                                setCustomerName((e.target.value).trim())
                                db.ledger.get({ customerName: e.target.value }).then((party) => {
                                    if (party) {
                                        setCustomerContact(party.customerContact)
                                        setCustomerDetails(party.customerDetails)
                                        setCustomerGST(party.customerGST)
                                    }

                                })
                            }}></IonInput>
                            <datalist id='customerList'>
                                {customers}
                            </datalist>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Customer Contact</IonLabel>
                            <IonInput type='tel' id="customerContact" placeholder='+91' value={CustomerContact} onIonInput={(e) => { setCustomerContact((e.target.value).trim()) }}></IonInput>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Customer Details</IonLabel>
                            <IonTextarea id="customerDetails" value={CustomerDetails} onIonInput={(e) => { setCustomerDetails((e.target.value).trim()) }} ></IonTextarea>
                        </IonItem>

                        {
                            gstenabled ? (
                                <IonItem>
                                    <IonLabel position='floating'>Customer GST</IonLabel>
                                    <IonInput type='text' id="customerGST" value={CustomerGST} onIonInput={(e) => { setCustomerGST((e.target.value).trim()) }}></IonInput>
                                </IonItem>
                            ) : ('')
                        }

                    </IonCol>

                    <IonCol sizeMd='3' offsetMd='5'>

                        {
                            gstenabled ? (
                                <IonItem>
                                    <IonLabel position='floating'>Sale Type</IonLabel>
                                    <IonSelect value={saletype} interface='popover' onIonChange={e => setSaletype(e.detail.value)}>
                                        <IonSelectOption value="intrastate">Intra-State</IonSelectOption>
                                        <IonSelectOption value="interstate">Inter-State</IonSelectOption>
                                    </IonSelect>
                                </IonItem>
                            ) : ('')
                        }

                        <IonItem>
                            <IonLabel position='stacked'>Date</IonLabel>
                            <input type='date' id="date" value={moment(date).format('YYYY-MM-DD')} onChange={(e) => { setDate(e.target.value) }}></input>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Invoice No.  {gstenabled && '(GST)'}</IonLabel>
                            <IonInput type='number' value={gstenabled ? gstinvoiceNo : invoiceNo} onIonChange={e => {
                                gstenabled ? setgstinvoiceNo(e.target.value) : setinvoiceNo(e.target.value)
                            }} id="invoiceNo" ></IonInput>
                        </IonItem>




                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol sizeMd='3'>
                        {
                            gstenabled ? (
                                <h6 id='total'>SubTotal : {subTotal.toFixed(2)}</h6>
                            ) : (
                                <h4 id='total'>Total : Rs. {total.toFixed(2)}</h4>
                            )
                        }
                    </IonCol>
                    <IonCol sizeMd='3' offsetMd='5' >{
                        gstenabled && (
                            <h5 id='total'>Total : {total.toFixed(2)}</h5>
                        )
                    }</IonCol>
                </IonRow>

                {ProductTable}
                <IonItemDivider />
                <IonRow>
                    <IonCol sizeMd='8'>
                        <AddProduct addProduct={addProduct} />
                    </IonCol>
                    <IonCol sizeMd='3'>

                        <IonButton shape='round' type='submit' onClick={updateBill}>Update Invoice</IonButton>
                    </IonCol>
                </IonRow>

                <iframe className='ion-hide' id='print' title='Print Invoice'></iframe>
            </IonContent>
        </IonPage>
    )
}

export default EditInvoice
